module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH",
    attrs: {
      "id": "Org"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Org",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Organization of the Edition")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The correspondence between Heinrich and Marga Himmler from 1927 to 1945 forms the core of this edition. Heinrich Himmler’s handwritten letters from the collection found in Israel and those of Marga Himmler from the Bundesarchiv Koblenz were transcribed in their entirety and printed in their original form for the first German edition. The rules of orthography that applied at the time were preserved, as well as all errors of grammar and spelling."), _c('span', {
    staticClass: "ePub-SUP"
  }, [_c('span', {
    staticClass: "footnote-link",
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notes1#footnote-17981-1",
      "id": "footnote-17981-1-backlink",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" This edition reproduces only a selection—especially for 1928, when the couple was just getting to know each other. These are excerpted because they contain countless repetitions of formulaic phrases. On the other hand, the increasingly brief letters from the years before the National Socialists came to power and from the war years are retained with almost no deletions.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("We have included further supplementary documents from the collection of the archive in Tel Aviv, especially selections from Gudrun’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Journal")]), _vm._v(" and the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Childhood Journal")]), _vm._v(" that Marga Himmler kept about her daughter and later about her foster son. Furthermore, we have included selections from Himmler’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Taschenkalender")]), _vm._v(" [Pocket Calendar]; letters from Gudrun to her father; and documents and letters from Hedwig Potthast. Other sources were also extraordinarily useful: the exhaustive biographies of Himmler by Peter Longerich (2008) and Klaus Mües-Baron (2011), and the editions of Himmler’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dienst-und Taschenkalender")]), _vm._v(" [official appointment books and pocket calendars] from 1937, 1940, and 1941–42.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The reader will find thematically organized commentaries inserted throughout the transcribed correspondence. These sections have been added to provide relevant context and background for the most important people, events, and places mentioned. An appendix at the back of the book contains more complete information about the persons in the text. Here we have consciously made a selection that includes information pertinent to these letters. We have avoided biographical sketches of people who may otherwise be found easily in handbooks, dictionaries, and other research tools about the Third Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For the commentary and the biographical appendix, the following sources were consulted: the extensive holdings in “Bestand NS 19” ([Inventory NS 19] "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Persönlicher Stab Reichsführer-SS")]), _vm._v(" [Personal Staff of the Reichsführer-SS]), as well as countless other holdings of the Bundesarchiv in Berlin-Lichterfelde. These include "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("SS-Führungsakten")]), _vm._v(" [Regulations of the SS]"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(", NSDAP-Parteimitgliedsakten")]), _vm._v(" [NSDAP Members’ Files], as well as personal files of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Rasse- und Siedlungshauptamts")]), _vm._v(" [SS Central Office for Race and Resettlement].")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("To make the text more readable we have kept notes to a minimum and have not included citations to source material. An extensive apparatus of sources and scholarly literature may be found in Appendix 2. In the commentaries, we have retained the common German place names used in the letters. The translators have included a glossary of German terms that occur frequently, especially NSDAP ranks and titles that have no obvious English equivalents.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70516b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/edition.vue
// module id = 69
// module chunks = 0